import {
    BaseState,
    SET_PATH_NAME,
    ReactRouterActionTypes,
    AuthActionTypes,
    SET_TOKEN,
    SET_LAB,
    SET_USER,
    UPDATE_TOKEN,
    LOGOUT,
    UPDATE_USER_PROFILE_STARTED,
    UPDATE_USER_PROFILE_SUCCESS,
    SEARCH_QUERY_CHANGE,
    SEARCH_STARTED,
    SEARCH_SUCCESS,
    SEARCH_END,
    LAB_UPDATE_START,
    LAB_UPDATE_END,
    FETCH_USERS_START,
    FETCH_USERS_SUCCESS,
    MenuActionTypes,
    SET_MENU_STATUS,
    QuickAccessTypes,
    FETCH_QUICK_ACCESS_START,
    FETCH_QUICK_ACCESS_SUCCESS,
    CreateNewUser,
    CREATE_NEW_USER_START,
    CREATE_NEW_USER_SUCCESS,
  } from "./types";

const initialState: BaseState = {
    path: '',
    token: "",
    lab: null,
    user: null,
    users: [],
    isLoading: false,
    searchResult : {
        categories: [],
        posts: [],
        forms: [],
        form_datas: []
    },
    searchQuery : '',
    isSearching : false,
    isMainMenuOpen: false,
    quickAccess: []
};

export function baseReducer(
    state=initialState,
    action: ReactRouterActionTypes | AuthActionTypes | MenuActionTypes | QuickAccessTypes | CreateNewUser
):BaseState {

    switch(action.type){
        case SET_MENU_STATUS:
            return Object.assign({}, state, {
                isMainMenuOpen: action.isOpen
            })
        case SET_PATH_NAME:
            return Object.assign({}, state, {
                path: action.path
            })
        case SET_TOKEN:
            localStorage.setItem('token',action.token);
            return Object.assign({}, state, {
                token: action.token
            })
        case SET_LAB:
            localStorage.setItem('lab',JSON.stringify(action.lab));
            return Object.assign({}, state, {
                lab: action.lab
            })
        case SET_USER:
            localStorage.setItem('user',JSON.stringify(action.user));
            return Object.assign({}, state, {
                user: action.user
            })
        case UPDATE_TOKEN:
            return Object.assign({}, state, {
                token: localStorage.getItem('token')
            })
        case LOGOUT:
            return Object.assign({}, state, {
                token: '',
                user: null,
                lab: null
            })
        case UPDATE_USER_PROFILE_STARTED:
            return Object.assign({}, state, {
                isLoading: true
            })
        case UPDATE_USER_PROFILE_SUCCESS:
            localStorage.setItem('user',JSON.stringify(action.user));
            return Object.assign({}, state, {
                user: action.user,
                isLoading: false,
                users: []
            })
        case SEARCH_QUERY_CHANGE:
            return Object.assign({}, state, {
                searchQuery: action.searchQuery
            })
        case SEARCH_STARTED:
            return Object.assign({}, state, {
                isSearching:true
            })
        case SEARCH_SUCCESS:
            return Object.assign({}, state, {
                searchResult : action.result,
                isSearching: false
            })
        case SEARCH_END:
            return Object.assign({}, state, {
                isSearching: false,
            })
        case LAB_UPDATE_START:
            return Object.assign({}, state, {
                isLoading: true,
            });
        case LAB_UPDATE_END:
            localStorage.setItem('lab',JSON.stringify(action.lab));
            return Object.assign({}, state, {
                isLoading: false,
                lab : action.lab
            })
        case FETCH_USERS_START:
            return Object.assign({}, state, {
                isLoading: true,
            })
        case FETCH_USERS_SUCCESS:
            return Object.assign({}, state, {
                isLoading: false,
                users: action.users
            })
        case FETCH_QUICK_ACCESS_START:
            return Object.assign({}, state, {
                isLoading: true
            })
        case FETCH_QUICK_ACCESS_SUCCESS:
            return Object.assign({}, state, {
                isLoading: false,
                quickAccess: action.quickAccess
            })
        case CREATE_NEW_USER_START:
            return Object.assign({}, state, {
                isLoading: true
            })
        case CREATE_NEW_USER_START:
                return Object.assign({}, state, {
                    isLoading: true
                })
        case CREATE_NEW_USER_SUCCESS:
                return Object.assign({}, state, {
                    isLoading: false,
                    users: []
                })
        default:
            let user = localStorage.getItem('user');
            user = user ? JSON.parse(user) : state.user;

            let lab = localStorage.getItem('lab');
            lab = lab ? JSON.parse(lab) : state.lab;

            let token = localStorage.getItem('token');
            return Object.assign({}, state, {
                user,
                lab,
                token
            })
            return state;
    }

} 